import React from 'react';

interface LogoIconProps {
  className?: string;
}

export const LogoIcon: React.FC<LogoIconProps> = ({ className = '' }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={className}
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      <polyline points="9 22 9 14 15 14 15 22"></polyline>
      <path d="M16 5.5a2.5 2.5 0 0 1 2 4 2.5 2.5 0 1 1-2-4z" />
      <path d="M6 12a4 4 0 0 1 8 0c0 2-2 3-4 4-2-1-4-2-4-4z" />
      <path d="M10.3 15l3.4-3.4" />
    </svg>
  );
};